<style scoped>
.justify {
  text-align: justify;
}

.video {
  width: auto;
  margin-bottom: 1px;
}

#player {
 width: 100%;
 background: white;
 top: 0;
 left: 0;
 right: 0;
}

.video-template .video {
  padding: 0px;
  margin: 0px 0px 12px;
  font-size: 12px;
}

</style>

<style>
.video-template .ivu-card-body{
  padding: 0 !important;
}

.video-template .video-holder{
  position: relative;
}

.video-template .video-detail {
    position: absolute;
    bottom: 0;
    background: rgba(0,0,0, 0.70);
    color: #fff;
    width: 100%;
    padding: 15px;
    vertical-align: middle;
    display: table;
    table-layout: fixed;
}

.video-detail .inner {
  vertical-align: middle;
  display: table-cell;
}

.inner.icon {
  margin-left:15px;
  white-space: nowrap;
  width: 16px;
  height: 24px
}
</style>

<template>
  <app-layout class="video-template">
    <Row type="flex" justify="center" style="position: relative; height: 100%; ">
      <keep-alive>
        <Col :span="24" style="position: absolute; max-width: 480px; padding-bottom: 60px;" v-show="!showModal">
          <Card class="video" shadow v-for="video in $store.state.brand.videos.data" :key="video.id" :id="video.id" style="padding-bottom: 0.05em">
            <div @click.stop.prevent="selectVideo(video.id)" class="video-holder">
              <img alt=" " :src="video.data.photo" width="100%" height="211px" style="display: table-row"/>
              <div class="video-detail">
                <div class="inner" style="padding-right: 15px" >
                  <p class="truncate" style="font-weight: bold;">{{ video.data.description }}</p>
                  <timeago style="color: rgb(170, 170, 170);" :since="video.rrule_parsed_date"> </timeago>
                </div>
                <Icon class="inner icon" type="ios-play" size="24"/>
              </div>
            </div>
          </Card>
        </Col>
      </keep-alive>
      <div id="player" v-if="showModal" style="min-height:85vh; overflow: auto">
        <!-- <p style="padding:10px 15px" align="right" @click="$router.go(-1)"><a><Icon type="android-close"></Icon> Close</a></p> -->
          <youtube
            :video-id="selectedVideo.id"
            :player-height="320" player-width="100%">
          </youtube>
        <div style="padding: 15px" v-show="selectedVideo.data">
          <p><b>{{ selectedVideo.data.title }}</b></p>
          <p><b>Description:</b> {{ selectedVideo.data.description }}</p>
        </div>
      </div>
    </Row>
  </app-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: "VideoComponent",
  data() {
    return {
      showModal: false,
      selectedVideo: {
        id: null,
        data: null
      }
    }
  },
  watch: {
    $route: function(n, o) {
      this.toggleModal(n)
    }
  },
  mounted() {
    console.log('mounted')
    this.toggleModal(this.$route)
    this.$store.dispatch('brand/getBrandVideos')
  },
  methods: {
    toggleModal(route) {
      if(route.query.id === undefined) {
        this.showModal = false
      } else {
        this.showModal = true
        this.selectVideo(route.query.id)
      }
    },

    selectVideo(videoId) {
      console.log(videoId)
      this.$router.push({path: '/videos', query: { id: videoId } });
      this.$store.dispatch('brand/getYoutubeVideosById', {brandId: 1, youtubeId: videoId} ).then((res) => {
        this.selectedVideo.id = res.data.id;
        this.selectedVideo.data = res.data.data
      })
    }
  }
};
</script>
